import { Link } from "react-router-dom";

export default function SocialIconLink({ href, to, label, Icon }) {
  const content = <Icon aria-hidden="true" />;

  if (to) {
    return (
      <Link className="icon-button" to={to} aria-label={label}>
        {content}
      </Link>
    );
  }

  return (
    <a className="icon-button" href={href} aria-label={label} target="_blank" rel="noreferrer">
      {content}
    </a>
  );
}
